import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ImageOff } from "lucide-react";

// <img> kan geen Bearer-header sturen: haal de foto als blob op en toon een object-URL (opgeruimd bij unmount).
// R1: een mislukte tegel is tikbaar om opnieuw te laden.
export const FotoBeeld = ({ bezoekId, foto, className = "", testid }) => {
  const [src, setSrc] = useState(null);
  const [fout, setFout] = useState(false);
  const [poging, setPoging] = useState(0);
  useEffect(() => {
    let url = null;
    let weg = false;
    setFout(false); setSrc(null);
    const ctrl = new AbortController();
    api.get(`/bezoeken/${bezoekId}/fotos/${foto.id}`, { responseType: "blob", signal: ctrl.signal })
      .then((r) => { if (!weg) { url = URL.createObjectURL(r.data); setSrc(url); } })
      .catch(() => { if (!weg) setFout(true); });
    return () => { weg = true; ctrl.abort(); if (url) URL.revokeObjectURL(url); };
  }, [bezoekId, foto.id, poging]);
  if (fout) {
    const opnieuw = (e) => { e.stopPropagation(); e.preventDefault(); setPoging((p) => p + 1); };
    return (
      <span data-testid={testid || `foto-fout-${foto.id}`} role="button" tabIndex={0} aria-label="Foto opnieuw laden" onClick={opnieuw}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") opnieuw(e); }}
        className={`flex flex-col items-center justify-center gap-1 bg-zinc-100 text-zinc-500 text-[11px] cursor-pointer ${className}`}>
        <ImageOff className="h-5 w-5" />Opnieuw laden
      </span>
    );
  }
  if (!src) return <div data-testid={testid} className={`bg-zinc-100 animate-pulse ${className}`} />;
  return <img data-testid={testid} src={src} alt="Foto van het bezoek" className={`object-cover ${className}`} />;
};
